<section fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="16px">
  <figure fxFlex="1/3" [style.padding]="padding|async">
    <img src="/assets/img/common/piggy-bank.svg" alt="Better Product Features" width="72" height="72"/>
    <figcaption>
      <h3>Better product features</h3>
      <ul>
        <li>NO DEDUCTIONS from approved loan amount</li>
        <li>NO HIDDEN processing fees and charges</li>
        <li>DISCOUNT for early full payment</li>
      </ul>
    </figcaption>
  </figure>
  <figure fxFlex="1/3" [style.padding]="padding|async">
    <!--! Icon made by [Round Icons](http://www.flaticon.com/authors/round-icons) from www.flaticon.com -->
    <img src="/assets/img/common/check-box.svg" alt="Easier to Comply" width="72" height="72"/>
    <h3>Easier to comply</h3>

    <ul>
      <li>Only 1 co-borrower required</li>
      <li>Fewer documentary requirements</li>
    </ul>
  </figure>
  <figure fxFlex="1/3" [style.padding]="padding|async">
    <img src="/assets/img/common/alarm-clock.svg" alt="Automated system" width="72" height="72"/>
    <h3>Automated system</h3>
    <ul>
      <li>24 hour approval</li>
      <li>Email and SMS reminders</li>
    </ul>
  </figure>
</section>
